export default {
  selectType: '账户类别',
  applys: '申请',
  accountNum: '账号 : ',
  applyRecords: '申请记录',
  noRecords: '暂无交易账户申请记录',
  orderId: '订单编号:',
  accountType: '账户类型',
  status: '状态',
  submitted: '审核中',
  checking: '审核中',
  pass: '审核中',
  reject: '审核失败',
  success: '已开通',
  nonactivated: '去开通',
  toapply: '申请开通',
  reapply: '重新申请',
  SUCCESS: '已开通',
  OPEN: '已开通',
  CLOSE: '已关闭',
  STOP: '已停止',
  REJECT: '申请失败',
  CHECKING: '审核中',
  PASS: '审核中',
  SUBMITTED: '已提交',
  TOSTOP: '去停用',

  refuseReason: '备注',
  apply: '账号申请',
  uploadAddress: '请上传住址证明',
  uploadId: '请上传身份证明',
  IdCardFace: '请上传身份证人像面',
  IdCardNational: '请上传身份证国徽面',
  picTypeErr: '仅接受JPG，PNG，PDF，JPEG格式',
  picSizeErr: '上传文件不能超过5M',
  addressTips: {
    tips: '温馨提示',
    line1: '1、拍照时请将证明文件平放，保持光照充足并避免反光；',
    line2:
      '2、请确保证明文件上的姓名、日期、住址等信息清晰可见，确保证明文件在最近三个月内；',
    line3:
      '3、证明文件可以是水电煤、电信、宽带等的增值税发票；或者经执业会计师、律师或公证人认证的信用卡对账单、水电、煤气、电信通知单等；',
    line4:
      '4、如您的住址与身分证上的相同，请再次上传身分证人像面作为住址证明。',
    upload_image_verify_isNull: '请上传住址证明',
    upload_image_verify_size: '上传图片不能超过5M',
    upload_image_verify_type: '仅接受JPG，PNG，PDF，JPEG格式'
  },
  idTips: {
    tips: '温馨提示：',
    line1: '1、拍照时请将证件平放；',
    line2: '2、请确保身份证边框完整、文字清晰可见；',
    line3: '3、照片上传后，若不满意可点击照片重拍。',
    upload_image_verify_isNull: '请上传身份证明',
    upload_image_verify_size: '上传图片不能超过5M',
    upload_image_verify_type: '仅接受JPG，PNG，PDF，JPEG格式'
  },
  infomationTips: {
    read: '请详细阅读以下内容',
    haveRead: '本人已阅读',
    rules: '「艾德证券期货有限公司业务条款及细则」。',
    rulesLink:
      'https://download-hangzhou.oss-cn-hangzhou.aliyuncs.com/pdf/SC/Business-Terms-and-Conditions.pdf',
    statement: '「风险披露声明」。',
    statementLink:
      'http://download.eddidapp.com/pdf/SC/Risk-Disclosure-Statement.pdf',
    textOne: '本人同意并确认，本人已根据',
    linkOneText: '「业务条款及细则」',
    linkOne:
      'https://download-hangzhou.oss-cn-hangzhou.aliyuncs.com/pdf/SC/Business-Terms-and-Conditions.pdf',
    textTwo: '中第十一章',
    linkTwoText: '「常设授权书」',
    linkTwo:
      'https://middleware-agreement-prod-public.oss-cn-shenzhen.aliyuncs.com/2021-07/e026eda6-58fc-4916-8831-60395c9700ed',
    lastText:
      '内之条款及细则授权及/或指示贵公司处置本人之证券、证券抵押品和款项，并且本人已详细阅读及明白该条款的内容。'
  },
  checkedConfirm: '本人确认本人之所有资料与开户时所提交的资料相同',
  checked: '请勾选',
  confirm: '确认申请',
  reSubmit: '修改并重新提交',
  errTips: {
    upload_address_verify_isNull: '请上传地址证明',
    upload_id_verify_isNull: '请上传身份证明',
    upload_image_verify_size: '上传图片不能超过5M',
    upload_image_verify_type: '仅接受JPG，PNG，PDF，JPEG格式',
    comfirmInfoError: '如您有资料更改，请联络客户服务',
    pleaseComfirmInfo: '请确认资料是否相同',
    pleaseReadText: '如已阅读，请勾选',
    pleaseSelectInvestmentExperience: '请选择您的外汇投资经验',
    pleaseSelectPurposeOfInvestment: '至少选择一项投资目标',
    purposeOfInvestmentTips:
      '买卖杠杆式外汇并不适合投资目标仅为「利息/股息收入」人士',
    riskToleranceTips:
      '杠杆式外汇交易为高风险产品，并不适合风险承受能力为「中」或「低」人士'
  },
  buttonText: {
    nonactivated: '去开通',
    success: '已开通',
    submitted: '审核中',
    checking: '审核中',
    pass: '审核中',
    reject: '申请失败'
  },
  confirmText: '本人确认本人之资料并无改变，与开户时所提交的资料相同。',
  applyFDTMTandC: `<span style="font-weight: 700">客户申请艾德证券期货有限公司(「艾德证券期货」)之期货日内交易账户服务前，请细阅本额外风险警告及条款（「本声明」）。</span> </br></br>
  <span style="font-weight: 700">期货日内交易账户之额外风险警告</span></br>
  此简要之风险警告声明并不能尽述有关期货日内交易账户之所有风险及其他重要事项。鉴于只针对向专业投资者及特选客户开放之少于最低按金要求建立新期货仓盘会有极高风险，阁下务须首先了解阁下将会订立之合约之特性(及其契约关系)以及阁下所能承担之风险程度，方能进行此种交易。此类少于最低按金要求建立新期货仓盘交易只适合少量专业投资者及特选客户。阁下应在仔细权衡本身之经验、目标、财政来源及其他有关情况后，方判断阁下是否适合进行此类期货保证金交易。 </br></br>
  <span style="font-weight: 700">一般期货及期权交易的风险</span></br>
  买卖期货合约或期权的亏损风险可以极大。在若干情况下，阁下所蒙受的亏损可能会超过最初存入的保证金数额。即使阁下设定了备用指示，例如「止损」或「限价」等指示，亦未必能够避免损失。市场情况可能使该等指示无法执行。阁下可能会在短时间内被要求存入额外的保证金。假如未能在指定的时间内提供所需款项，阁下的未平仓合约可能会被平仓。然而，阁下仍然要对阁下的账户内任何因此而出现的欠款负责。因此，阁下在买卖前应研究及理解期货合约及期权，以及根据本身的财政状况及投资目标，仔细考虑这种买卖是否适合阁下。如果阁下买卖期权，便应熟悉行使期权及期权到期时的程序，以及阁下在行使期权及期权到期时的权利与责任。 </br></br>
  <span style="font-weight: 700">针对以少于最低按金要求建立新期货仓盘交易的风险</span></br>
  此类以少于最低按金要求建立新期货仓盘交易的风险极高。由于此类交易的开仓保证金要求的金额较正常期货交易合约本身的开仓保证金要求相对只有三分之一，因而在此类交易中发挥极高「杠杆」作用。市场轻微的波动也会对阁下投入或将需要投入的资金造成极大比例的影响。对阁下来说，这种杠杆作用可说是弊多于利。因此阁下可能会损失全部开仓保证金及为维持本身的仓盘而向有关商号存入的额外金额。如果市况不利阁下所持仓盘或保证金水平提高，阁下会遭追收保证金，须在短时间内存入额外资金以维持本身仓盘。假如阁下未有在指定时间内缴付额外的资金，或市场上期货合约价格进一步波动令保证金水平进一步降低至爆仓水平时，阁下可能会被迫在亏损情况下平仓，而所有因此出现的短欠数额一概由阁下承担。例子：假设爆仓风险率为80%，于付足够开仓保证金要求下，期货保证金交易市况不利于你反向波动大概下跌600点，客户之交易合约将被强制平仓；但当客户以少于最低按金要求建立新仓，期货保证金交易市况不利于你反向波动大概只需下跌200点<span style="font-weight: 700">（市况波动比正常付足够开仓保证金少大概三分之一情况下）</span>，客户之交易合约便会强制平仓。 </br></br>
  <span style="font-weight: 700">减低风险交易指示或投资策略</span></br>
  即使阁下采用某些旨在预设亏损限额的交易指示(如「止损」或「止损限价」指示)，也有可能起不了任何作用，因为在极高杠杆比率及市况波动情况下，这些交易指示基本上无法执行。 </br></br>
  <span style="font-weight: 700">针对申请成为专业投资者的客户之警告</span></br>
  专业投资者更多的是指具有一定交易经验和专业知识的个人交易者或机构。 「专业投资者」的定义载于《证券及期货条例》附表1第1部第1条，「个人专业投资者」定义为根据《专业投资者规则》第5(1)及5(2)条所指的个人；「法团专业投资者」定义为根据《专业投资者规则》第6(a)、6(b)及6(c)条所指的法团。阁下应仔细衡量自身之条件是否附合专业投资者之要求，及这种极高风险买卖是否适合阁下。一旦阁下确认成为专业投资者并进行此类以少于最低按金要求建立新期货仓盘交易，阁下所面对极高之亏损风险是一般投资者无法承受的。艾德证券期货不会就阁下之亏损负上任何责任。敬请阁下在申请前三思。 </br></br>
  <span style="font-weight: 700">期货日内交易账户之额外条款</span></br>
  此「额外条款」为附带于艾德证券期货有限公司之业务条款及细则，进行以少于最低按金要求建立新期货仓盘交易的客户除受业务条款及细则约束外，同时需受此额外条款约束。阁下务须首先了解此额外条款，方能进行此种交易。 </br></br>
  1 开立「期货日内交易账户」额外要求:</br>
    &nbsp;1.1 于艾德证券期货成功开立期货账户(保证金)至少满3个月；</br>
    &nbsp;1.2 在最近至少一年客户之期货交易账户内没有任何下列一种情况出现： </br>
    &nbsp;&nbsp;&nbsp;1.2.1 未能履行保证金的纪录；或</br>
    &nbsp;&nbsp;&nbsp;1.2.2 遭强制平仓纪录；或</br>
    &nbsp;&nbsp;&nbsp;1.2.3 遭退票纪录；</br>
    &nbsp;1.3 在最近一个月内有最少一次买卖期货持仓过夜的交易纪录；及</br>
    &nbsp;1.4 维持平稳健财务状况。 </br>
    &nbsp;1.5 艾德证券期货保留最终全权酌情决定权。 </br></br>
  2 「期货日内交易账户」申请及交易条款</br>
  &nbsp;2.1 客户知悉艾德证券期货会将客户于现有期货交易账户内的所有资金，全数转账至新开立的期货日内交易账户内；</br>
  &nbsp;2.2 期货日内交易账户只提供香港交易所、美国芝加哥商品交易所及新加坡交易所之特定期货产品；</br>
  &nbsp;2.3 每日强制平仓</br>
  &nbsp;&nbsp;&nbsp;2.3.1 期货日内交易账户内所有持仓将不能隔夜，所有开仓必需即日平仓。如客户于指定强制平仓时间前未有自行把所有开仓平仓，艾德证券期货将会把所有仓位于下列指定强制平仓时间强制平掉，<span style="font-weight: 700">且不作任何额外通知</span></br>
  香港交易所每日强制平仓时间 (香港时间) : 3:30pm</br>
  美国芝加哥商品交易所每日强制平仓时间 (香港时间) : 3:00am</br>
  新加坡交易所每日强制平仓时间 (香港时间) : 3:00pm</br>
  &nbsp;2.4 任何时候若期货日内交易账户内持仓风险率一旦低于百份之八十(80%)，艾德证券期货将会执行强制平仓，直至持仓风险率提高至百份之一百( 100%)或以上；</br>
  &nbsp;2.5 艾德证券期货拥有就强制平仓最终全权酌情决定权。 </br>
  &nbsp;2.6 若客户申请取消期货日内交易账户服务后，30历日内不可再申请该服务。 </br></br>
  3 取消「期货日内交易账户」资格</br>
  &nbsp;3.1 若下列任何一种情况出现于客户之期货日内交易账户内，其期货日内交易账户之资格将<span style="font-weight: 700">被立即被取消</span>：</br>
  &nbsp;&nbsp;&nbsp;3.1.1 客户未能于指定时间内履行艾德证券期货发出的追加保证金要求；</br>
  &nbsp;&nbsp;&nbsp;3.1.2 客户的持仓因账户内持仓风险率低于百份之八十 (80%)，而遭艾德证券期货执行强制平仓；或</br>
  &nbsp;&nbsp;&nbsp;3.1.3 客户存入的个人支票遭退票，未能清算。 </br>
  &nbsp;3.2 个别被取消资格的客户若希望重新申请成为期货日内交易账户客户，该客户必须在最近至少一年内没有任何未能履行保证金责任的记录。 </br>
  &nbsp;3.3 若出现任何事件，并导致艾德证券期货有理由怀疑客户未能证明其有贯彻履行保证金责任及/或能维持稳健的财务状况，艾德证券期货将立即重新评估该客户是否仍符合作为期货日内交易账户客户的资格。 </br></br>
  4 艾德证券期货将会定时检视期货日内交易账户客户资格，确保客户符合期货日内交易账户额外要求。并就「期货日内交易账户」额外条款拥有最终全权酌情决定权。 </br></br>`,
  requestError: {
    EXIT_APPROVAL_RECORD: '存在正在审核的记录，不能重复提交'
  },
  tipsText1: '如有其他资料更改，请联系客户服务:',
  tipsText2:
    '+852 2655 0338 / 400 120 0068（中国内地免费热线） | 电邮：cs@eddidsec.com',
  fdtmAgreeText: {
    text1:
      '本人已阅读及明白艾德证券期货之「期货日内交易账户额外风险警告及条款」，并同意受其所约束',
    text2:
      '本人同意将本人于现有期货交易账户内的所有资金全数转账至日内交易账户内',
    text3:
      '「期货日内交易账户」只适用于合资格客户，艾德证券期货拥有最终全权酌情决定权。'
  },
  mt5ApplyForm: {
    tipsTitle:
      '本人现申请开立<strong class="font_blod">「杠杆式外汇账户(保证金)交易账户」</strong>',
    recomfireText: '请重新确认以下个人信息',
    investmentExperienceText: '外汇投资经验是:',
    investmentExperienceOps: {
      a: '少于一年',
      b: '一至五年',
      c: '六至十年',
      d: '多于十年'
    },
    investmentObjectiveText: '投资目标是（选择所有适用）:',
    investmentObjectiveOps: {
      a: '投机',
      b: '对冲',
      c: '资产增值',
      d: '利息/股息收入'
    },
    riskToleranceText: '风险承受能力是:',
    riskToleranceTextOps: {
      a: '高',
      b: '中',
      c: '低'
    },
    confirmInformationText:
      '本人确认本人其他资料并无改变，与开户时所提交的资料相同。',
    confirmInformationTips:
      '如有其他资料更改，请联络客户服务: +852 2655 0338 / 400 120 0068（中国内地免费热线）｜电邮：<a href="mailto:cs@eddidsec.com">cs@eddidsec.com</a>',
    riskStatement: {
      header: '本人确认本人已完全细阅、明白及确认本',
      rules: ' 「程式交易风险声明」',
      rulesLink:
        'http://download.eddidapp.com/pdf/SC/program-trading-risk-statement.pdf'
    },
    riskStatementFoot:
      '如欲停止「程式交易」功能，请联络客户服务: +852 2655 0338 / 400 120 0068（中国内地免费热线）｜电邮：<a href="mailto:cs@eddidsec.com">cs@eddidsec.com</a>',

    articleContent: `
    <p><strong class="font_blod">本人谨此向艾德证券期货有限公司确认及声明：</strong></p>
    <p>1.本人已阅读及明白艾德证券期货之
      <a class="font-16" href="https://download-hangzhou.oss-cn-hangzhou.aliyuncs.com/pdf/SC/Business-Terms-and-Conditions.pdf" target="_blank">
        <span class="statement">「业务条款及细则」</span></a>，并同意受其所约束；</p>
    <p>2.本人已阅读及明白艾德证券期货之
      <a class="font-16" href="http://download.eddidapp.com/pdf/SC/Risk-Disclosure-Statement.pdf" target="_blank">
        <span class="statement">「风险披露声明」</span></a>及
      <a class="font-16" href="http://download.eddidapp.com/pdf/EN/order-execution-policy.pdf" target="_blank">
        <span class="statement">「订单执行政策」</span></a>，并清楚了解杠杆式外汇交易属高风险投资产品；</p>
    <p>3.本人已明白杠杆式外汇交易的亏损风险可以十分重大。本人所蒙受的亏损可能超过本人的最初保证金款额。本人将要为本人的账户所出现的任何逆差负责。</p>
    `
  },
  pleaseInput: '请输入',
  aboutMargin: '相关保证金',
  aboutMarginTitle1:
    '本人及/或本人配偶未持有艾德证券期货任何相关的保证金账户',
  aboutMarginTitle2:
    '本人及/或本人配偶没有单独或共同控制艾德证券期货的其他保证金账户35%或以上的表决权',
  aboutMarginTitle3:
    '本人没有以客户的同一集团公司旗下的其他公司在艾德证券期货开立保证金账户',
  aboutMarginAccountName: '账户持有人姓名',
  aboutMarginAccountNumber: '账户号码',
  aboutMarginAccountNameErr: '请填写账户持有人姓名',
  aboutMarginAccountNumberErr: '请填写账户号码',
  illegalMarginAccountNumber: '请填写正确的账户号码',
  oneInfo: '由于您：选择开通期货交易账户，必须勾选至少一项衍生品相关经验',
  logOutQues: {
    title:
      '本人申请即日起停用本人「期货日内交易账户」，谨向艾德证券期货有限公司确认：',
    Q1: '本人同意于成功停用「期货日内交易账户」后，30日内不可再申请此服务',
    Q2:
      '本人同意若账户停用后有任何结余（正或负），所有结余将全数转账至本人之期货交易账户内。'
  },
  agree: '您需要阅读并勾选相关协议才能提交',
  fmdInfo: '期货日内交易账户停用',
  companyName: '目前公司名称：',
  employmentYears: '受雇年期：',
  employmentYearsError: '该数值不在可输入范围内',
  yearsError: '请输入正整数',
  notZeroFirst: '整数不能以0开头',
  hideYears: '直至目前为止，本人为退休/无业',
  employmentYearsEnter: '请输入受雇年期',
  notAccount:
    '您无法开通当前交易账户，请致电 +852 2655 0338 / 400 120 0068（中国内地免费热线） 或 电邮至 cs@eddidsec.com 与我们联络',
  complianceDeclarationTextOne: '本人确认已阅读、理解并同意',
  declarationLink: 'https://download-hangzhou.oss-cn-hangzhou.aliyuncs.com/pdf/SC/ChineseMainlandInvestorComplianceDeclaration.pdf',
  declarationLinkContent: '《中国内地投资者合规声明书》',
  declarationLastText: '的全部內容。'
}
